document.addEventListener("DOMContentLoaded", function () {
  new Swiper(".mak_banner-container.swiper", {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 2,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
});
document.addEventListener("DOMContentLoaded", () => {
  const stickyMenu = document.getElementById("stickyMenu");
  const stickyWrapper = document.getElementById("stickyMenuWrapper");
  const header = document.querySelector("header");
  const mainContent = document.getElementById("MainContent");

  if (!stickyMenu || !header || !mainContent || !stickyWrapper) return;

  let stickyMenuHeight = stickyMenu.offsetHeight;
  let headerHeight = header.offsetHeight;

  const updateHeights = () => {
    stickyMenuHeight = stickyMenu.offsetHeight;
    headerHeight = header.offsetHeight;

    document.documentElement.style.setProperty(
      "--header-height",
      `${headerHeight}px`
    );
    document.documentElement.style.setProperty(
      "--sticky-menu-height",
      `${stickyMenuHeight}px`
    );
  };

  let stickyMenuOriginalTop =
    stickyWrapper.getBoundingClientRect().top + window.scrollY;

  const checkSticky = () => {
    const scrollY = window.scrollY;
    const shouldStick = scrollY >= stickyMenuOriginalTop - headerHeight;

    stickyMenu.classList.toggle("is-sticky", shouldStick);
  };

  updateHeights();
  checkSticky();

  new ResizeObserver(() => {
    updateHeights();
    stickyMenuOriginalTop =
      stickyWrapper.getBoundingClientRect().top + window.scrollY;
    checkSticky();
  }).observe(header);

  let ticking = false;
  window.addEventListener("scroll", () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        checkSticky();
        ticking = false;
      });
      ticking = true;
    }
  });
});
document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector("header");
  const stickyWrapper = document.getElementById("stickyMenuWrapper");

  if (!header || !stickyWrapper) return;

  const getOffsetHeight = () => {
    return header.offsetHeight + stickyWrapper.offsetHeight;
  };

  document
    .querySelectorAll('.mak_items-sticky[href^="#"]')
    .forEach((anchor) => {
      anchor.addEventListener("click", function (e) {
        e.preventDefault(); // ❗ Block default behavior

        const targetId = this.getAttribute("href").slice(1);
        const target = document.getElementById(targetId);
        if (!target) return;

        const offset = getOffsetHeight();
        const targetTop = target.getBoundingClientRect().top + window.scrollY;

        // Smooth scroll with offset
        window.scrollTo({
          top: targetTop - offset,
          behavior: "smooth",
        });

        // ❌ Don't update URL — no pushState, no hash
      });
    });
});

document.addEventListener("DOMContentLoaded", () => {
  const stickyLinks = document.querySelectorAll(".mak_items-sticky");
  const sections = [];

  stickyLinks.forEach((link) => {
    const id = link.getAttribute("href")?.replace("#", "");
    const section = document.getElementById(id);
    if (section) {
      sections.push({ id, element: section });
    }
  });

  const highlightCurrentSection = () => {
    const headerHeight = document.querySelector("header")?.offsetHeight || 0;
    const stickyHeight =
      document.getElementById("stickyMenuWrapper")?.offsetHeight || 0;
    const scrollY = window.scrollY;
    const offset = headerHeight + stickyHeight;

    for (let i = sections.length - 1; i >= 0; i--) {
      const { id, element } = sections[i];
      const top = element.getBoundingClientRect().top + scrollY;

      if (scrollY + offset >= top - 10) {
        stickyLinks.forEach((link) => link.classList.remove("active"));
        const activeLink = document.querySelector(
          `.mak_items-sticky[href="#${id}"]`
        );
        if (activeLink) activeLink.classList.add("active");
        break;
      }
    }
  };

  window.addEventListener("scroll", highlightCurrentSection);
});

// MOBILE
document.addEventListener("DOMContentLoaded", () => {
  const stickyMenuMobile = document.getElementById("stickyMenuMobile");
  const stickyWrapperMobile = document.getElementById(
    "stickyMenuWrapperMobile"
  );
  const header = document.querySelector("header");
  const mainContent = document.getElementById("MainContent");

  if (!stickyMenuMobile || !header || !mainContent || !stickyWrapperMobile)
    return;

  let stickyMenuHeight = stickyMenuMobile.offsetHeight;
  let headerHeight = header.offsetHeight;

  const updateHeights = () => {
    stickyMenuHeight = stickyMenuMobile.offsetHeight;
    headerHeight = header.offsetHeight;

    document.documentElement.style.setProperty(
      "--header-height",
      `${headerHeight}px`
    );
    document.documentElement.style.setProperty(
      "--sticky-menu-height",
      `${stickyMenuHeight}px`
    );
  };

  let stickyMenuOriginalTop =
    stickyWrapperMobile.getBoundingClientRect().top + window.scrollY;

  const checkSticky = () => {
    const scrollY = window.scrollY;
    const shouldStick = scrollY >= stickyMenuOriginalTop - headerHeight;

    stickyMenuMobile.classList.toggle("is-sticky", shouldStick);
  };

  updateHeights();
  checkSticky();

  new ResizeObserver(() => {
    updateHeights();
    stickyMenuOriginalTop =
      stickyWrapperMobile.getBoundingClientRect().top + window.scrollY;
    checkSticky();
  }).observe(header);

  let ticking = false;
  window.addEventListener("scroll", () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        checkSticky();
        ticking = false;
      });
      ticking = true;
    }
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const stickyLinksMobile = document.querySelectorAll(
    "#stickyMenuWrapperMobile .mak_items-sticky"
  );
  const mobileSections = [];

  stickyLinksMobile.forEach((link) => {
    const id = link.getAttribute("href")?.replace("#", "");
    const section = document.getElementById(id);
    if (section) {
      mobileSections.push({ id, element: section });
    }
  });

  const highlightCurrentSectionMobile = () => {
    const headerHeight = document.querySelector("header")?.offsetHeight || 0;
    const stickyHeight =
      document.getElementById("stickyMenuWrapperMobile")?.offsetHeight || 0;
    const scrollY = window.scrollY;
    const offset = headerHeight + stickyHeight;

    for (let i = mobileSections.length - 1; i >= 0; i--) {
      const { id, element } = mobileSections[i];
      const top = element.getBoundingClientRect().top + scrollY;

      if (scrollY + offset >= top - 10) {
        stickyLinksMobile.forEach((link) => link.classList.remove("active"));
        const activeLink = document.querySelector(
          `#stickyMenuWrapperMobile .mak_items-sticky[href="#${id}"]`
        );
        if (activeLink) activeLink.classList.add("active");
        break;
      }
    }
  };

  window.addEventListener("scroll", highlightCurrentSectionMobile);
});
function openTab(evt, tabName) {
  var i, tabcontent, tablinks;
  var section = evt.currentTarget.closest("[data-section-id]");
  var sectionId = section.getAttribute("data-section-id");

  tabcontent = section.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }

  tablinks = section.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].classList.remove("active");
  }

  section.querySelector("#" + tabName).style.display = "block";
  evt.currentTarget.classList.add("active");
}
function openPatientModal() {
  const modal = document.getElementById('patient-info-modal');
  modal.style.display = 'flex';
  document.body.style.overflow = 'hidden'; // Prevent background scrolling
}
function closePatientModal() {
  const modal = document.getElementById('patient-info-modal');
  modal.style.display = 'none';
  document.body.style.overflow = 'auto'; // Restore scrolling
}
// Close modal when clicking outside the content
document.addEventListener('click', function(event) {
  const modal = document.getElementById('patient-info-modal');
  if (event.target === modal) {
    closePatientModal();
  }
});
// Close modal with Escape key
document.addEventListener('keydown', function(event) {
  if (event.key === 'Escape') {
    closePatientModal();
  }
});